import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grow, Stack, Typography, useTheme } from '@mui/material';

import InovonicsPendantAnimation from 'src/components/drawers/animations/InovonicsPendantAnimation';
import PullCordAnimation from 'src/components/drawers/animations/PullCordAnimation';
import { DeviceTriggerState } from 'src/hooks/usePendingDeviceTriggers';
import type { AllocationType } from 'src/store/sageAdminApi';

const ResetInstructions: Partial<Record<AllocationType, string>> = {
    PULL_CORD: 'Push the lever up to reset',
    BUTTON_WITH_RESET: 'Hold the magnet on top of the pendant to reset',
};

const ResetAnimations: Partial<Record<AllocationType, () => JSX.Element>> = {
    PULL_CORD: () => <PullCordAnimation />,
    BUTTON_WITH_RESET: () => <InovonicsPendantAnimation />,
};

export default function DeviceResetCardBody({ device }: { device: DeviceTriggerState }) {
    const { spacing } = useTheme();
    const { allocationType } = device;
    const resetInstruction = allocationType ? ResetInstructions[allocationType] : undefined;
    const renderResetAnimation = allocationType ? ResetAnimations[allocationType] : undefined;

    if (!device.isPending) {
        return (
            <Grow in>
                <Stack sx={{ gap: 2 }}>
                    <Box
                        sx={{
                            width: '100%',
                            aspectRatio: '1',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <Box
                            sx={{
                                width: '50%',
                                aspectRatio: '1',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                border: '1px solid',
                                borderColor: 'grey.400',
                                color: 'success.main',
                            }}
                        >
                            <FontAwesomeIcon icon={faCheck} size="5x" />
                        </Box>
                    </Box>
                    <Typography variant="body1" sx={{ textAlign: 'center', p: spacing(1) }}>
                        Device Reset
                    </Typography>
                </Stack>
            </Grow>
        );
    }

    return (
        <Stack sx={{ gap: 2, alignItems: 'center' }}>
            {renderResetAnimation ? renderResetAnimation() : null}
            {resetInstruction && (
                <Typography variant="body1" sx={{ textAlign: 'center' }}>
                    {resetInstruction}
                </Typography>
            )}
        </Stack>
    );
}
